export default data => {
  let subMenu = document.getElementById('projectsSubMenu');
  if (data.next.namespace == 'projects') {
    subMenu.classList.remove('md:hidden');
  } else {
    subMenu.classList.add('md:hidden');
  }

  let removeAllSubMenus = () => {
    let s;
    let subs = document.getElementsByClassName('projSubs');
    for (s = 0; s < subs.length; s++) {
      subs[s].classList.add('md:hidden');
    }
  };

  let topHighlight = area => {
    let allMenuItems = document.getElementsByClassName('topProjMenuLinks');
    let ami;
    for (ami = 0; ami < allMenuItems.length; ami++) {
      let theId = allMenuItems[ami].getAttribute('data-id');
      if (area == theId) {
        allMenuItems[ami].classList.remove('opacity-30');
      } else {
        allMenuItems[ami].classList.add('opacity-30');
      }
    }
  };

  let entryId = data.next.container.getAttribute('data-entry');
  let secondMenus = document.getElementsByClassName('projMenuLinks');
  let sm;
  for (sm = 0; sm < secondMenus.length; sm++) {
    let secondId = secondMenus[sm].getAttribute('data-id');
    if (entryId == secondId) {
      secondMenus[sm].classList.remove('opacity-30');
    } else {
      secondMenus[sm].classList.add('opacity-30');
    }
  }

  let area = data.next.container.getAttribute('data-project-area');
  topHighlight(area);

  if (area != 'none') {
    removeAllSubMenus();
    let subSubMenuName = 'projectsSubMenu-' + area;
    console.log(subSubMenuName);
    let subSubMenu = document.getElementById(subSubMenuName);
    if (subSubMenu != undefined && subSubMenu != null) {
      subSubMenu.classList.remove('md:hidden');
    }
    
  } else {
    removeAllSubMenus();
  }
};
